module.exports = __webpack_public_path__ + "static/img/icon06.1b898788.svg";